
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/components/testimonial",
      function () {
        return require("private-next-pages/components/testimonial.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/components/testimonial"])
      });
    }
  